/* MarieOdile collectietegels-carrousel.
   Sectie-gescoped, idempotent, en bestand tegen Theme Editor section reloads.
   Alleen actief als de sectie "Carrousel i.p.v. raster" heeft aanstaan;
   zonder carrousel blijft alles gewoon een statisch CSS-grid. */
(function () {
  'use strict';

  function initTiles(root) {
    if (!root || root.dataset.moTilesInit === '1') return;
    root.dataset.moTilesInit = '1';

    var track = root.querySelector('[data-mo-tiles-track]');
    var viewport = root.querySelector('[data-mo-tiles-viewport]');
    var tiles = root.querySelectorAll('[data-mo-tile]');
    var prev = root.querySelector('[data-mo-tiles-prev]');
    var next = root.querySelector('[data-mo-tiles-next]');
    if (!track || !viewport || !tiles.length) return;

    var index = 0;

    function step() {
      var a = tiles[0].getBoundingClientRect();
      if (tiles.length < 2) return a.width;
      return tiles[1].getBoundingClientRect().left - a.left;
    }
    function maxIndex() {
      var s = step();
      if (!s) return 0;
      return Math.max(0, tiles.length - Math.max(1, Math.floor(viewport.clientWidth / s)));
    }
    function apply() {
      index = Math.min(Math.max(index, 0), maxIndex());
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
    }

    function onPrev() { index -= 1; apply(); }
    function onNext() { index += 1; apply(); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    var t;
    function onResize() { clearTimeout(t); t = setTimeout(apply, 150); }
    window.addEventListener('resize', onResize);

    root.moTilesDestroy = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      window.removeEventListener('resize', onResize);
      root.dataset.moTilesInit = '';
    };

    apply();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mo-tiles-carousel]').forEach(initTiles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mo-tiles-carousel]').forEach(function (r) {
      if (typeof r.moTilesDestroy === 'function') r.moTilesDestroy();
    });
  });
})();
